import React                     from 'react';
import { Observe }               from 'rewire-core';
import { WithStyle}              from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import Typography                from '@material-ui/core/Typography';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
  },
});

interface IInboxProps {

}

type InboxProps = WithStyle<ReturnType<typeof styles>, IInboxProps>;

class Inbox extends React.Component<InboxProps> {
  constructor(props: InboxProps) {
    super(props);
  }

  render() {
    const {classes} = this.props;

    return <Observe render={() => (
      <div className={classes.root}>
        <Typography variant='h5'>My Inbox</Typography>
      </div>
    )} />;
  }
}

export default withStyles<IInboxProps>(styles, Inbox);
